import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Model } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import { Can } from '@morningtrain/react-auth'
import CardSummarySection from 'widgets/economy/partials/CardSummarySection'
import GuestCountBarChartLoader from 'widgets/charts/loaders/GuestCountBarChartLoader'
import { Link } from '@morningtrain/react-navigation'
import CookieFilter from "support/filters/CookieFilter";

export default function GuestCountEconomyWidget () {
  return (
    <Can permission='api.economy.guest_count'>
      <Widget>
        <Translator namespace='economy.guest_count'>
          <UI.Card paddingBottom={false}>
            <SpaceBetween>
              <UI.Text weight='medium' size='lg'>
                <Translation name='title' />
              </UI.Text>
              <Link route='app.economy.guest_count'>
                <UI.Button color='lightgray'>
                  <Translation name='view_all' />
                </UI.Button>
              </Link>
            </SpaceBetween>

            <Model resourceName='economy' operationName='guest_count'>
              <CookieFilter name='period' cookieKey='page.filters.period' />
              <SelectedDepartmentFilter />

              <div className='flex flex-col flex-grow flex-shrink pt-6'>

                <div className='flex justify-between'>
                  <UI.Text weight='medium' size='3xl'>
                    <Displays.Integer name='guest_count' />
                    <UI.Text weight='medium' size='xs' color='gray' className='pl-2'>
                      <Translation name='visitors' />
                    </UI.Text>
                  </UI.Text>

                  <UI.Legend className='mt-2 mb-4 w-24 flex-col' space={false}>
                    <UI.LegendItem className='w-24' colorHex='#616DE1'>
                      <Translation name='generic.this_period' />
                    </UI.LegendItem>
                    <UI.LegendItem className='w-24' colorHex='#CED2F6'>
                      <Translation name='generic.last_year' />
                    </UI.LegendItem>
                  </UI.Legend>
                </div>

                <div className='w-full h-52'>
                  <GuestCountBarChartLoader />
                </div>

              </div>

              <UI.HorizontalList border className='mb-4 -mx-8'>
                <CardSummarySection />
              </UI.HorizontalList>

            </Model>

          </UI.Card>
        </Translator>
      </Widget>
    </Can>
  )
}
